// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReviewStatus = {
    PendingReview: 'PENDING_REVIEW',
    Acknowledged: 'ACKNOWLEDGED',
    Resolved: 'RESOLVED',
    Ignored: 'IGNORED'
} as const;
export type ReviewStatus = typeof ReviewStatus[keyof typeof ReviewStatus];


export function instanceOfReviewStatus(value: any): boolean {
    for (const key in ReviewStatus) {
        if (Object.prototype.hasOwnProperty.call(ReviewStatus, key)) {
            if (ReviewStatus[key as keyof typeof ReviewStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReviewStatusFromJSON(json: any): ReviewStatus {
    return ReviewStatusFromJSONTyped(json, false);
}

export function ReviewStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewStatus {
    return json as ReviewStatus;
}

export function ReviewStatusToJSON(value?: ReviewStatus | null): any {
    return value as any;
}

export function ReviewStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ReviewStatus {
    return value as ReviewStatus;
}
